module.exports = __webpack_public_path__ + "img/email.1d6d79ab.svg";